// extracted by mini-css-extract-plugin
export var sliderRange = "_q7-2";
export var sliderRoot = "_q7-0";
export var sliderThumb = "_q7-3";
export var sliderTrack = "_q7-1";